export default __webpack_public_path__ + "static/media/redux-seeklogo.com.a9567540.svg";